import type { QueryClient } from '@tanstack/react-query';
import { SIGNAL_DETAIL_QUERY_KEY } from './useUpdateSignal';
import { SIGNAL_AUDIT_LOGS_QUERY_KEY } from '../useSignalAuditLogs';

const SIGNAL_LIST_QUERY_KEYS = [
  'endpoint-signals-paginated',
  'signal-counts',
  'ai-component-signal-counts',
] as const;

type InvalidateQueriesClient = Pick<QueryClient, 'invalidateQueries'>;

export const invalidateSignalQueriesAfterFindingStatusChange = ({
  queryClient,
  signalId,
}: {
  queryClient: InvalidateQueriesClient;
  signalId?: string | null;
}): void => {
  if (!signalId) {
    return;
  }

  void queryClient.invalidateQueries({
    queryKey: [SIGNAL_DETAIL_QUERY_KEY, signalId],
  });
  void queryClient.invalidateQueries({
    queryKey: [SIGNAL_AUDIT_LOGS_QUERY_KEY, signalId],
    exact: false,
  });

  for (const queryKey of SIGNAL_LIST_QUERY_KEYS) {
    void queryClient.invalidateQueries({
      queryKey: [queryKey],
      exact: false,
    });
  }
};
